
<template>
    <div class="p-grid p-col-12">
      <!--Marcações-->
      <div class="p-col-12 p-lg-3">
        <div class="card p-shadow-1" style="height: 400px;">
          <h5>Marcações Hoje</h5> 
          <DataTable :value="marcacoes" class="p-datatable-sm p-datatable-striped" 
            scrollHeight="290px" :scrollable="true" v-if="marcacoes.length > 0">					
            <Column field="hora" header="Hora"></Column>					
            <Column>
                <template #body="slotProps">
                  <Button icon="pi pi-download" title="Baixar Comprovante" 
                    class="p-button-rounded p-button-primary" @click="downloadMarcacaoPdf(slotProps.data)"/>		
                </template>
            </Column>
          </DataTable>
          <div class="p-d-flex p-jc-center" v-else>
            <div class="p-col-12 p-lg-12">
              <div class="p-d-flex p-jc-center p-mb-4">
                <i class="pi pi-search-minus ik-text-secondary p-mt-5" style="font-size: 8rem"></i>
              </div>
              <div class="p-d-flex p-jc-center">
                <h4 class="ik-text-secondary">Nenhuma informação encontrada</h4>
              </div>
            </div>
          </div>
        </div>
      </div> 
      <!--Resumo-->
      <div class="p-col-12 p-lg-4">
        <div class="card p-shadow-1" style="height: 400px;">
          <h5>Resumo</h5>
          <div v-if="temDadoResumo">
            <div class="p-col-12 p-lg-12" v-for="item in itensResumo"  v-bind:key="item.nome">     
              <div class="p-d-flex p-jc-between">
                <span>{{ item.nome }}</span>
                <span :class=getClassResumo(item.valor)>{{ item.valor }}</span>
              </div>      
            </div>
          </div>        
          <div class="p-d-flex p-jc-center" v-else>
            <div class="p-col-12 p-lg-12">
              <div class="p-d-flex p-jc-center p-mb-4">
                <i class="pi pi-search-minus ik-text-secondary p-mt-5" style="font-size: 8rem"></i>
              </div>
              <div class="p-d-flex p-jc-center">
                <h4 class="ik-text-secondary">Nenhuma informação encontrada</h4>
              </div>
            </div>
          </div>      
        </div>
      </div>  
      <!--Solicitações-->
      <div class="p-col-12 p-lg-5">
        <div class="card p-shadow-1" style="height: 400px;">
          <h5>Solicitações Pendentes</h5>
          <DataTable :value="solicitacoes" class="p-datatable-sm p-datatable-striped" 
            scrollHeight="290px" :scrollable="true" v-if="solicitacoes.length > 0">					
            <Column field="data" header="Data Solicitação">
              <template #body="slotProps">
                {{ formatarStrData(slotProps.data.data) }}
              </template>
            </Column>	
            <Column field="dataPonto" header="Ponto">
              <template #body="slotProps">
                {{ formatarStrData(slotProps.data.dataPonto) }}
              </template>
            </Column>	
            <Column field="tipo" header="Tipo"></Column>
          </DataTable>
          <div class="p-d-flex p-jc-center" v-else>
            <div class="p-col-12 p-lg-12">
              <div class="p-d-flex p-jc-center p-mb-4">
                <i class="pi pi-search-minus ik-text-secondary p-mt-5" style="font-size: 8rem"></i>
              </div>
              <div class="p-d-flex p-jc-center">
                <h4 class="ik-text-secondary">Nenhuma informação encontrada</h4>
              </div>
            </div>
          </div>
        </div>
      </div>  
    </div>
  </template>
  
  <script>
  import PontoService from '@/service/PontoService';
  import { exibirMensagem } from '@/global';
  import { mapGetters } from 'vuex';
  
  export default {
      pontoService: null,
      data() {
          return {
            marcacoes: [],
            solicitacoes: [],
            itensResumo: [],
            temDadoResumo: false
          }
      },
      methods: {
        ...mapGetters('sessao', ['getUsuario', 'limparSessao']),
        /**
         * 
         */
        getEspelho() {
          let hoje = new Date();
          let requisicao = {
            id: this.getUsuario().id,
            grupo: this.getUsuario().grupo,
            mes: hoje.getMonth() + 1,
            ano: hoje.getFullYear(),
            tipoDispositivo: 'Web'
          }
          this.pontoService.espelho(requisicao, 'wt=f')
          .then(resp => {
            this.atualizarResumo(resp.data.resumo);
            this.getMarcacoes();   
          })
          .catch(erro => {
            if(erro.response.status == 401) {
              this.logout();
            } else {
              exibirMensagem(this, erro)
            }            
          });         
        },
        /**
         * 
         */
        getMarcacoes() {
          let dataInicio = new Date((new Date().getTime() - (86400000 * 9)));
          let dataFinal = new Date();        
          let requisicao = {
            id: this.getUsuario().id,
            grupo: this.getUsuario().grupo,
            dataInicio: this.formatarData(dataInicio),
            dataFinal: this.formatarData(dataFinal),
            tipoDispositivo: 'Web'
          }
          this.pontoService.marcacoes(requisicao, 'wt=f')
          .then(resp => {  
            this.atualizarMarcacoes(resp.data);
            this.getSolicitacoes();   
          })
          .catch(erro => {
            if(erro.response.status == 401) {
              this.logout();
            } else {
              exibirMensagem(this, erro)
            }
          }); 
        },
        /**
         * 
         */
        getSolicitacoes() {
          let requisicao = {
            id: this.getUsuario().id,
            grupo: this.getUsuario().grupo,           
            tipoDispositivo: 'Web'
          }
          this.pontoService.solicitacoesPendentes(requisicao, 'wt=f')
          .then(resp => {      
            this.solicitacoes = resp.data;   
          })
          .catch(erro => { 
            if(erro.response.status == 401) {
              this.logout();
            } else {
              exibirMensagem(this, erro)
            }
          }); 
        },     
        /**
         * 
         */
         downloadMarcacaoPdf(marcacao) {      
          let requisicao = {
            id: this.getUsuario().id,
            idMarcacao: marcacao.id,
            tipoDispositivo: 'Web'
          }
          this.pontoService.downloadMarcacaoPdf(requisicao)
          .then(resp => {
            let blob = new Blob([resp.data]);     
            let nomeArquivo = 'comprovante_'+(Date.now())+'.pdf';
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, nomeArquivo);
            } else {
              var aLink = document.createElement('a');
              document.body.appendChild(aLink);
              var url = window.URL.createObjectURL(blob);
              aLink.setAttribute('id', Date.now());
              aLink.setAttribute('href', url);
              aLink.setAttribute("download", nomeArquivo);
              aLink.click();
              setTimeout(function(){window.URL.revokeObjectURL(url)}, 200);
              aLink.remove();
            }
          })
          .catch(erro => { 
            if(erro.response.status == 401) {
              this.logout();
            } else {
              if(erro.response.headers['ik-response']) {
                erro.response.data = JSON.parse(erro.response.headers['ik-response']);
              }
              exibirMensagem(this, erro)
            }
          });
        },   
        /**
         * 
         */
        atualizarMarcacoes(pontos) {
          this.pontoHoje = null;
          this.marcacoes = [];
          let date = new Date();
          let hoje = date.getFullYear();
          hoje += '-' + ((date.getMonth() + 1 )< 10 ? '0' + (date.getMonth() + 1 ) : (date.getMonth() + 1 )); 
          hoje += '-' + (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()); 
          pontos.forEach(ponto => {
            if(ponto.data == hoje) {            
              this.marcacoes = ponto.marcacoes;
            }
          });
        },
        /**
         * 
         */
        atualizarResumo(resumo) {        
          this.itensResumo = [];
          this.itensResumo.push({ nome: 'Horas Trabalhadas (H)', 
              valor: (resumo.horasTrabalhadas ? resumo.horasTrabalhadas : '') }
          );
          this.itensResumo.push({ nome: 'Horas Extras (H)', 
              valor: (resumo.horasExtras ? resumo.horasExtras : '') }
          );
          this.itensResumo.push({ nome: 'Banco de Horas (H)', 
              valor: (resumo.saldoBancoHoras ? resumo.saldoBancoHoras : '') }
          );
          this.itensResumo.push({ nome: 'Adicional Noturno (H)', 
              valor: (resumo.adicionalNoturno ? resumo.adicionalNoturno : '') }
          );
          this.itensResumo.push({ nome: 'Atraso (Qtd.)', 
              valor: (resumo.atrasos == 0 ? '' : resumo.atrasos) }
          );
          this.itensResumo.push({ nome: 'Falta (Qtd.)', 
              valor: (resumo.faltas == 0 ? '' : resumo.faltas) }
          );
          this.itensResumo.push({ nome: 'Falta de Marcação (Qtd.)', 
              valor: (resumo.faltasMarcacoes == 0 ? '' : resumo.faltasMarcacoes) }
          );
          this.itensResumo.push({ nome: 'Saída Antecipada (Qtd.)', 
              valor: (resumo.saidasAntecipadas == 0 ? '' : resumo.saidasAntecipadas) }
          ); 
          this.itensResumo.push({ nome: 'Excesso no Intervalo da Refeição (Qtd.)', 
              valor: (resumo.excessosIntervaloRefeicao == 0 ? '' : resumo.excessosIntervaloRefeicao) }
          );
          let qtdComValor = 0;
          this.itensResumo.forEach(item => {
            if(item.valor) {
              qtdComValor++;
            }
          });
          if(qtdComValor > 0) {
            this.temDadoResumo = true;
          }
        }, 
        /**
         *       
         */
        getClassResumo(valor) {
          let cssClass = '';
          if(valor.toString().includes(':')) {
            cssClass = 'ik-badge-resumo-success';
            if(valor.startsWith('-')) {
              cssClass = 'ik-badge-resumo-danger';
            }
          } else if(valor > 0) {
            cssClass = 'ik-badge-resumo-danger';          
          }
          return cssClass;
        },
        /**
         * 
         * @param {*} data 
         */
        formatarData(data) {
          if(!data) {
            return null;
          }
          let strData = null;
          if(data instanceof Date) {
            let dt = data;
            let mes = dt.getMonth();
            let dia = dt.getDate();
            strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
          } else {
            let partes = data.split('/');
            strData = partes[2] + '-' + partes[1] + '-' + partes[0];
          }
          return strData;
        },
        /**
         * 
         * @param {*} strDate 
         */
        formatarStrData(strDate) {
          if(!strDate) {
            return '';
          }
          let arr = strDate.split('-');
          return arr[2] + '/' + arr[1] + '/' + arr[0];
        },
        /**
         * 
         */
        logout() {
          this.limparSessao();			
          this.$router.push('/login?exp=sessao_expirada');
        }      
      },
      created() {
        this.pontoService = new PontoService();  
        this.getEspelho();
      }
  }
  </script>
  
  <style>
  
  </style>